'use strict';

exports.__esModule = true;
exports.SPLITTED_DATA_TYPES = undefined;
exports.getAddedItems = getAddedItems;
exports.getRemovedItems = getRemovedItems;
exports.getUniqueDisplayedId = getUniqueDisplayedId;
exports.getOriginalId = getOriginalId;
exports.getItemId = getItemId;
exports.getTemplateCompIds = getTemplateCompIds;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _modelUtils = require('../modelUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint consistent-return:0*/
var DELIMITER = '__';
var SPLITTED_DATA_TYPES = exports.SPLITTED_DATA_TYPES = ['data', 'design'];

/* get Array[ids] or Array[{_id:id}] and returns array of id's*/
function getIdsFromItems(items) {
  return _lodash2.default.map(items, function (item) {
    return _lodash2.default.isString(item) ? item : item._id;
  });
}

/*get Array[ids] or Array[{_id:id}] and returns format of {item: itemData, index: index in array}*/
function reduceItems(data, ids) {
  var dataFormatted = _lodash2.default.map(data, function (v) {
    if (_lodash2.default.isString(v)) {
      return { _id: v };
    }
    return v;
  });
  return _lodash2.default.reduce(dataFormatted, function (result, item, index) {
    if (_lodash2.default.includes(ids, item._id)) {
      result.push({ item: item, index: index });
    }
    return result;
  }, []);
}

/*return added repeater items - check what newly ids were added
 * return {item: itemData, index: index in array} */
function getAddedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var newlyAddedItemsIds = _lodash2.default.difference(newItemsIds, currentDataIds);
  return reduceItems(newData, newlyAddedItemsIds);
}

/*return removed repeater items - check what ids were removed
 * return {item: itemData, index: index in array} */
function getRemovedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var removedIds = _lodash2.default.difference(currentDataIds, newItemsIds);
  return reduceItems(currentData, removedIds);
}

function getUniqueDisplayedId(originalId, itemId) {
  return originalId + DELIMITER + itemId;
}

function getOriginalId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[0];
}

function getItemId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[1];
}

function getTemplateCompIds(RMI, repeaterId, itemsData) {
  var templateCompIds = (0, _modelUtils.getAllCompsUnderRoot)(_lodash2.default.get(RMI, '_model'), repeaterId);
  var itemsId = _lodash2.default.compact(_lodash2.default.map(itemsData, function (itemData) {
    return _lodash2.default.get(itemData, 'item._id');
  }));
  return _lodash2.default.reduce(itemsId, function (result, itemId) {
    return result.concat(_lodash2.default.map(templateCompIds, function (templateCompId) {
      return getUniqueDisplayedId(templateCompId, itemId);
    }));
  }, []);
}
//# sourceMappingURL=repeaterItemsUtils.js.map